import React from 'react'
import { Link } from '@hub/link'
import { Imposter } from '@hub/imposter'
import { Text } from '@hub/text'
import { ShoppingCartMediumIcon } from '@hub/icon'
import { useToken, HubStyleObject } from '@hub/design-system-base'
import analyticsUtils from '../../../helpers/analytics-utils'
import trackEvent from '../../../helpers/analytics-utils/track-event'
interface CartProps {
  count?: number
  url?: string
  sx?: HubStyleObject
}

const MAX_CART_COUNT = 9

export const Cart: React.FC<CartProps> = ({ sx, url = '/', count = 0 }) => {
  const hitTargetGrowthX = useToken('space', 'spacing-sm')
  return (
    <Link
      href={url}
      sx={{
        position: 'relative',
        display: 'flex',
        alignSelf: 'stretch',
        alignItems: 'center',
        top: [null, null, '-4px'],
        // Increase the hit target of the button
        '&:before': {
          content: '""',
          position: 'absolute',
          left: `-${hitTargetGrowthX}`,
          right: `-${hitTargetGrowthX}`,
          top: 0,
          bottom: 0,
        },
        ...sx,
      }}
      aria-label={`View your cart. ${count === 0 ? 'No' : count} item${
        count === 1 ? '' : 's'
      }.`}
      onClick={() =>
        trackEvent(
          analyticsUtils.categories.UNIVERSAL_HEADER,
          analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK,
          analyticsUtils.labels.VIEW_CART
        )
      }
    >
      <Imposter
        constrained={false}
        impose={
          // Why aren't we using a <Label> here? Unfortuantely the requirements
          // here deviate far enough from <Label> that it ends up undoing and
          // overriding more styles than introduced by doing it manually below.
          <Text
            tone="strong"
            sx={{
              display: count === 0 ? 'none' : 'block',
              padding: '3px',
              borderRadius: '4px',
              // Ensure the padding _and_ the border take up space within the
              // box
              boxSizing: 'content-box',
              // Give the box a square-ish shape for thin numbers (eg: "1")
              minWidth: '1ch',
              // When text is thinner than '1ch', center it
              textAlign: 'center',
              border: '1px solid white',
              background: 'vibrantTeal',
              color: 'blueCharcoal',
              // When we have "9+", make sure it doesn't wrap
              whiteSpace: 'nowrap',
              // These magic numbers come from running the desired font size
              // through Capsize: https://seek-oss.github.io/capsize/
              fontSize: '12px',
              lineHeight: '8px',
              '::before': {
                content: "''",
                marginBottom: '0.022em',
                display: 'table',
              },
            }}
          >
            {count <= MAX_CART_COUNT ? count : `${MAX_CART_COUNT}+`}
          </Text>
        }
        position="top-left"
        marginLeft="50%"
        marginTop="-2px"
      >
        <ShoppingCartMediumIcon boxSize="size-icon-md" />
      </Imposter>
    </Link>
  )
}
